import type { RoleDto } from "../data";

const date = (index: number) =>
  `2026-02-${String((index % 28) + 1).padStart(2, "0")}T10:00:00.000Z`;

export const rolesFixtures: readonly RoleDto[] = Array.from(
  { length: 24 },
  (_, offset) => {
    const index = offset + 1;
    return {
      id: `role-${String(index).padStart(2, "0")}`,
      accountId: "account-01",
      nameEn: `Role ${String(index).padStart(2, "0")}`,
      nameAr: `دور ${String(index).padStart(2, "0")}`,
      isActive: index % 3 !== 0,
      permissions:
        index % 2 === 0
          ? ["billing.invoices.list.view"]
          : ["fleet.vehicles.list.view"],
      createdAt: date(index),
      updatedAt: date(index + 1),
    };
  },
);
